import { useEffect, useState } from "react";
import ImageService from "../../services/generalApi/image.service";

const cache = new Map<string, string>();

export function useSignedImage(originalUrl: string) {
  const [signedUrl, setSignedUrl] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const signUrl = async () => {
      if (cache.has(originalUrl)) {
        setSignedUrl(cache.get(originalUrl)!);
        return;
      }

      try {
        const response = await ImageService.getFilePath(originalUrl);
        const signed = response || originalUrl;
        cache.set(originalUrl, signed);
        if (isMounted) setSignedUrl(signed);
      } catch (error) {
        console.error("Error firmando imagen:", error);
        if (isMounted) setSignedUrl(originalUrl);
      }
    };

    signUrl();

    return () => {
      isMounted = false;
    };
  }, [originalUrl]);

  return signedUrl;
}
